
// 工单状态过滤
const StatusFiltering = function (value) {
    let type = ''
    switch (value) {
        case 'wait_received':
            type = '待接收'
            break;
        case 'wait_dispatch':
            type = '待指派'
            break;
        case 'wait_pickup':
            type = '待认领'
            break;
        case 'wait_do':
            type = '执行中'
            break;
        case 'finish':
            type = '完结'
            break;
    }
    return type;
}
// 完成状态
const StatusResultOption = function (value) {
    let type = ''
    switch (value) {
        case '1':
            type = '完成'
            break;
        case '2':
            type = '未完成'
            break;
        case '3':
            type = '处理中'
            break;
    }
    return type;
}
// 工单操作记录
const WorkOrderFiltering = function (value) {
    let type = ''
    switch (value) {
        case 'create_order':
            type = '创建工单'
            break;
        case 'change_order':
            type = '变更工单'
            break;
        case 'receive_order':
            type = '接收工单'
            break;
        case 'split_task':
            type = '拆分任务'
            break;
        case 'task_dispatch':
            type = '任务指派'
            break;
        case 'auto_create_task':
            type = '系统自动创建任务'
            break;
        case 'task_pick_up':
            type = '任务认领'
            break;
        case 'submit_task':
            type = '提交任务'
            break;
        case 'order_finish"':
            type = '工单结单'
            break;
    }
    return type;
}


//时间戳转换
const timestampToTime = function (timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
    var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
    var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m + s;
}
const timestampToTimeB = function (timestamp) {
    var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return Y + M + D;
}
export default {
    StatusFiltering,
    WorkOrderFiltering,
    timestampToTime,
    timestampToTimeB,
    StatusResultOption,
}